export const DEFAULT_DATE = new Date().toISOString().slice(0, 16);

export const DEFAULT_DATE_RANGE = {
  start: DEFAULT_DATE,
  end: DEFAULT_DATE,
};
